import Link from 'next/link';
import { Nav } from 'react-bootstrap';

type Props = {
  activeKey: 'trips' | 'departures';
};

export default function SearchPageTabs({ activeKey }: Props) {
  return (
    <Nav variant="tabs" className="my-2" defaultActiveKey={'trips'}>
      <Nav.Item key="trips">
        <Link href="/trips" passHref legacyBehavior>
          <Nav.Link active={activeKey === 'trips'} as="a">
            Adventures
          </Nav.Link>
        </Link>
      </Nav.Item>
      <Nav.Item key={'departures'}>
        <Link href="/trips/departures" passHref legacyBehavior>
          <Nav.Link active={activeKey === 'departures'} as="a">
            Departures
          </Nav.Link>
        </Link>
      </Nav.Item>
    </Nav>
  );
}
